/*
 * This class is copied from Backstage 1.8.2.
 * We performed a lot of changes, be careful when upgrading.
 */

import { EntityErrorResult } from '@agilelab/plugin-wb-catalog-extension-common';
import { parseEntityRef, stringifyEntityRef } from '@backstage/catalog-model';
import { useRouteRef } from '@backstage/core-plugin-api';
import { TemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-common';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { selectedTemplateRouteRef } from '../../routes';
import { CustomTemplate } from '../ScaffolderPage/utils';
import { EntityCard } from './EntityCard';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      borderRadius: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        maxWidth: '430px',
      },
    },
  }),
);

export type TemplateCardProps = {
  template: TemplateEntityV1beta3;
};

export const TemplateCard = (props: {
  template: TemplateEntityV1beta3;
  error?: EntityErrorResult;
  customTemplates: CustomTemplate[];
}) => {
  const { template, error, customTemplates } = props;
  const classes = useStyles();
  const templateRoute = useRouteRef(selectedTemplateRouteRef);

  const { name, namespace } = parseEntityRef(stringifyEntityRef(template));
  const href = templateRoute({ templateName: name, namespace });

  return (
    <EntityCard
      entity={template}
      href={href}
      className={classes.card}
      error={error}
      customTemplates={customTemplates}
    />
  );
};
